import { connect } from "react-redux";
import Dashboard from "./Dashboard";

export default connect(null, null)(Dashboard);